import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the RoundPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'round',
})
export class RoundPipe implements PipeTransform {
  transform(value: number, ...args) {
    return Math.round(value);
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/round/round.ts